module.exports = __webpack_public_path__ + "static/media/no-extra.95684e01.svg";